<template>
  <v-card class="round-card background-2 mb-4">
    <v-card-title class="pa-3">
      <v-icon color="primary" class="mr-3">mdi-clock-check-outline</v-icon>
      <span>SLA: {{ sla.sla_name }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-3">
      <sla-progress-bar
        v-if="sla.response_state !== 'none'"
        label="Tempo di Risposta"
        :elapsed-minutes="sla.response_elapsed_minutes"
        :target-minutes="sla.response_target_minutes"
        :state="sla.response_state"
      />
      <sla-progress-bar
        v-if="sla.resolution_state !== 'none'"
        :class="{ 'mt-3': sla.response_state !== 'none' }"
        label="Tempo di Risoluzione"
        :elapsed-minutes="sla.resolution_elapsed_minutes"
        :target-minutes="sla.resolution_target_minutes"
        :state="sla.resolution_state"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import SlaProgressBar from './SlaProgressBar.vue'

export default {
  name: 'SlaInfoPanel',

  components: {
    SlaProgressBar,
  },

  props: {
    sla: {
      type: Object,
      required: true,
    },
  },
}
</script>
